import { LinkedStudy, LinkedStudySchema } from "@shared/types";

export async function getStudy(study: string): Promise<LinkedStudy> {
  const url = new URL("/api/study", import.meta.env.VITE_BACKEND_URL);

  url.searchParams.set("study", study);

  const response = await fetch(url);

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error ?? `Request failed with status ${response.status}`);
  }

  const data = await response.json();
  const result = LinkedStudySchema.safeParse(data);

  if (!result.success) {
    throw new Error("Invalid study returned from service");
  }

  return result.data;
}
